<template>
  <div>
    <el-dialog
      v-if="dialog_release"
      class="dialog_big_box"
      :title="
        langSet == 'cn' ? '请填写您的应答信息' : 'Please fill in your response'
      "
      :visible.sync="dialog_release"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <div class="dialog_line"></div>
        <div class="dialog_box_top">
          <div class="dialog_title_picture">
            <img :src="userInfo.avatar_uri" alt="" />
            <img
              v-if="userInfo.exhibitor_long_id"
              src="@/assets/authentication.png"
              alt=""
            />
          </div>
          <div style="color: #ffffff">
            <div class="dialog_title_name">
              <div>{{ userInfo.nickname }}</div>
              <div>{{ userInfo.position }}</div>
            </div>
            <div class="dialog_company">{{ userInfo.company_name }}</div>
          </div>
          <!--          <img class="dialog_edit_img" src="@/assets/edit.png" alt=""/>-->
        </div>
        <el-form
          :model="form"
          label-position="top"
          label-width="auto"
          style="max-width: 600px"
        >
          <el-form-item
            :label="langSet == 'cn' ? '产品类别' : 'Product Category'"
            prop="name"
          >
            <el-select
              v-model="form.product_category_id"
              placeholder=""
              size="large"
              style="width: 240px"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="
              langSet == 'cn'
                ? '上传图片（最多三张）'
                : 'Upload Images (Up to 3)'
            "
            prop="fileList"
            v-if="publication_type == 1"
          >
            <el-upload
              :action="$Url + '/pc/Upload/image'"
              :headers="headers"
              list-type="picture-card"
              :on-success="handleLogoSuccess"
              :on-error="handleLogoError"
              :on-remove="handleRemove"
              :on-preview="handlePreview"
              :file-list="fileList"
              :limit="3"
              :on-exceed="handleExceed"
              :before-upload="beforeUpload"
              style="display: flex"
              :class="{ 'hide-upload': fileList.length >= 3 }"
            >
              <i v-if="fileList.length < 3" class="el-icon-plus"></i>

              <!-- 修复预览功能的模板 -->
              <div slot="file" slot-scope="{ file }">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <!--            <div v-if="form.fileList.length<3" class="image_list">-->
            <!--             <div class="item_image" v-for="(item,index) in form.fileList" :key="index">-->
            <!--               <el-image :src="item">-->
            <!--                 <div class="upload-span">-->
            <!--                   <span class="upload-icon" @click.stop="handlePictureCardPreview($imgUrl+license_pic)"><i class="el-icon-zoom-in"></i></span>-->
            <!--                   <span class="upload-icon" @click.stop="handleRemove()" style="margin-left: 20px"><i class="el-icon-delete"></i></span>-->
            <!--                 </div>-->
            <!--               </el-image>-->
            <!--             </div>-->
            <!--            </div>-->
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '需求描述' : 'Requirement Description'"
            prop="name"
          >
            <el-input
              type="textarea"
              :rows="7"
              :placeholder="
                langSet == 'cn'
                  ? '请详细描述您的需求'
                  : 'Please provide a detailed description of your requirements'
              "
              v-model="form.requirement"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span class="dialog-footer">
        <!--    <el-button @click="dialogVisible = false">取 消</el-button>-->
        <el-button class="dialog_submit" type="primary" @click="submit">{{
          langSet === "cn" ? "提 交" : "Submit"
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>


<script>
import { business_publish_add } from "@/api/business_api";

export default {
  name: "dialog_release",
  props: ["publication_type", "options", "dialog_release", "label_value"],
  data() {
    return {
      dialogVisible: false,
      form: {
        requirement: "",
        product_category_id: "",
        fileList: [],
      },
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      dialogImageUrl: "",
      disabled: false,
      headers: {
        token: localStorage.getItem("token"),
      },
      fileList: [],
      langSet: "",
    };
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    // 上传成功处理
    handleLogoSuccess(response, file, fileList) {
      this.fileList = fileList;
      this.$message.success("图片上传成功");
    },
    // 上传失败处理
    handleLogoError(err, file, fileList) {
      this.$message.error("图片上传失败");
      console.error("上传错误:", err);
    },
    // 删除图片
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => file.url != item.url);
    },

    // 预览图片
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 超出数量限制提示
    handleExceed() {
      this.$message.warning("最多只能上传3张图片");
    },
    // 上传前校验
    beforeUpload(file) {
      const isImage = file.type.includes("image/");
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("只能上传图片格式!");
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
      }

      return isImage && isLt2M;
    },

    async submit() {
      let fileArr = [];
      let product_category = "";
      let product_category_en = "";
      this.fileList.forEach((item) => {
        fileArr.push(item.response.data.uri);
      });
      this.options.forEach((item) => {
        if (item.id == this.form.product_category_id) {
          product_category = item.category_name;
          product_category_en = item.en_category_name;
        }
      });
      let data = {
        category: this.publication_type, //需求类别：1-供应类 2-采购类
        product_category_id: this.form.product_category_id, //产品类别id
        product_category: product_category, //产品类别中文
        product_category_en: product_category_en, //产品类别英文
        imgs: fileArr, //需求图片
        requirement: this.form.requirement, //需求描述
      };
      const res = await business_publish_add(data);
      this.$message.success(res.msg);
      this.handleClose();
    },
    handleClose() {
      this.$emit("add_round");
    },
  },
};
</script>


<style scoped lang="scss">
//弹窗
.dialog_big_box {
  /deep/ .el-dialog {
    top: 5%;
    width: 480px !important;
    height: auto !important;
    background: #ffffff;
    border-radius: 20px;
    position: relative;
  }

  .dialog-footer {
    //position: absolute;
    display: flex;
    justify-content: center;
    //margin: 30px;
  }

  /deep/ .el-dialog__body {
    padding: 0 30px 30px 30px !important;
  }

  .dialog_line {
    width: 100%;
    border-bottom: 1px solid #f3f3f3;
  }

  .dialog_box_top {
    position: relative;
    display: flex;
    padding: 10px;
    align-items: center;
    //height: 96px;
    background: #004190;
    border-radius: 8px;
    margin: 20px 0 15px 0;
  }

  .dialog_title_picture {
    position: relative;
    margin-right: 10px;
  }

  .dialog_title_picture > img:first-child {
    width: 65px;
    height: 65px;
    border-radius: 50%;
  }

  .dialog_title_picture > img:nth-child(2) {
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .dialog_title_name {
    display: flex;
    margin-bottom: 5px;
    align-items: center;
  }

  .dialog_title_name > div:nth-child(1) {
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
  }

  .dialog_title_name > div:nth-child(2) {
    margin-left: 10px;
    font-weight: 400;
    font-size: 15px;
    color: #ffffff;
    line-height: 21px;
    text-align: center;
    font-style: normal;
  }

  .dialog_company {
    font-weight: 400;
    font-size: 15px;
    color: #ffffff;
    line-height: 21px;
    text-align: left;
    font-style: normal;
  }

  .dialog_edit_img {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }

  .dialog_footer {
  }

  .dialog_submit {
    width: 180px;
    height: 42px;
    border-radius: 9px;
    background-color: #004190;
    border-color: #004190;
  }

  .dialog_submit:hover {
    background-color: #004190;
    opacity: 0.9;
  }

  .dialog_submit:focus {
    background-color: #004190;
    opacity: 1;
  }

  /deep/ .el-form-item__label {
    line-height: 14px;
  }

  /* 隐藏上传按钮 */
  .hide-upload ::v-deep .el-upload--picture-card {
    display: none;
  }
  /deep/.el-upload-list__item {
    width: 97px;
    height: 97px;
  }

  /deep/.el-upload--picture-card {
    width: 97px;
    height: 97px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  //.image_list{
  //  display: flex;
  //  align-items: center;
  //
  //  .item_image{
  //    width: 97px;
  //    height: 97px;
  //  }
  //  .el-image{
  //    width: 97px;
  //    height: 97px;
  //    position: relative;
  //    .upload-span{
  //      position: absolute;
  //      z-index: 99;
  //      top: 0;
  //      left: 0;
  //    }
  //  }
  //
  //}
}

@media only screen and (max-width: 767px) {
  .dialog_big_box {
    /deep/ .el-dialog {
      top: 5%;
      width: 6.54rem !important;
      height: auto !important;
      background: #ffffff;
      border-radius: 0.38rem;
    }
    /deep/ .el-dialog__body {
      padding: 0 0.29rem 0.29rem 0.29rem !important;
    }
  }
}
</style>